import { render } from "./Vue3Popper.vue?vue&type=template&id=595d0236&scoped=true&ts=true"
import script from "./Vue3Popper.vue?vue&type=script&lang=ts"
export * from "./Vue3Popper.vue?vue&type=script&lang=ts"

import "./Vue3Popper.vue?vue&type=style&index=0&id=595d0236&scoped=true&lang=css"

import exportComponent from "/builds/digitalsign/frontendweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-595d0236"]])

export default __exports__